import {Injectable} from '@angular/core';
import {Action, createSelector, State, StateContext} from '@ngxs/store';
import {Observable, tap} from 'rxjs';
import {LoadLegalDocument} from './legal-documents.actions';
import {LegalDocumentsService} from '@tisa-group/core';
import {patch} from '@ngxs/store/operators';

export type LegalDocumentsStateModel = Record<string, any>;

@State<LegalDocumentsStateModel>({
  name: 'LegalDocuments',
  defaults: {},
})
@Injectable()
export class LegalDocumentsState {
  @Action(LoadLegalDocument)
  loadEvent(
    ctx: StateContext<LegalDocumentsStateModel>,
    action: LoadLegalDocument,
  ): Observable<LegalDocumentsStateModel> | LegalDocumentsStateModel {
    const documents = ctx.getState();
    const {documentType} = action;
    const {language} = action;
    const {applicationId} = action;

    if (documents[LegalDocumentsState.normalizeActionParams(action)]) {
      return documents[LegalDocumentsState.normalizeActionParams(action)];
    }

    return this.documentsService
      .getDocument(language, documentType, applicationId)
      .pipe(
        tap(result =>
          ctx.setState(
            patch({[LegalDocumentsState.normalizeActionParams(action)]: result}),
          ),
        ),
      );
  }

  static getLegalDocument(
    params: LoadLegalDocument,
  ): (state: LegalDocumentsStateModel) => any {
    return createSelector<(state: LegalDocumentsStateModel) => any>(
      [LegalDocumentsState],
      state => {
        return state[LegalDocumentsState.normalizeActionParams(params)];
      },
    );
  }

  static normalizeActionParams(action: LoadLegalDocument): string {
    return `${action.documentType}-${action.language}-${action.applicationId}`;
  }

  constructor(readonly documentsService: LegalDocumentsService) {}
}
